import { t } from 'i18next'

// TODO: move this to a own file
/**
 * Each field can have multiple errors.
 */
export type FormErrorFields<T> = Record<keyof T, Array<typeof errorMessages>>

// Form
export type ValidationForm<T> = {
  onSubmit: (data: T) => void
  errorFields?: FormErrorFields<T>
  defaultData?: Partial<T>
}

export const errorMessages = new Proxy(
  {},
  {
    get: (_, key: string) => {
      const messages: Record<string, string> = {
        invalid: t('translation:errors.invalid'),
        required: t('translation:errors.required'),
        'invalid-number': t('translation:errors.invalid-number'),
        'auth/wrong-password': t('translation:errors.auth/wrong-password'),
        'auth/too-many-requests': t('translation:errors.auth/too-many-requests'),
        'auth/user-not-found': t('translation:errors.auth/user-not-found'),
        'auth/email-already-in-use': t('translation:errors.auth/email-already-in-use'),
        'auth/weak-password': t('translation:errors.auth/weak-password'),
        'auth/invalid-login-credentials': t('translation:errors.auth/invalid-login-credentials'),
        contactAlreadyExists: t('translation:errors.contactAlreadyExists')
      }

      return messages[key]
    }
  }
)
